// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const FigmaUploadFilledIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const ink = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M15.2595 22.2503H8.73949C3.82949 22.2503 1.72949 20.1503 1.72949 15.2403V15.1103C1.72949 10.6703 3.47949 8.53027 7.39949 8.16027C7.79949 8.13027 8.17949 8.43027 8.21949 8.84027C8.25949 9.25027 7.95949 9.62027 7.53949 9.66027C4.39949 9.95027 3.22949 11.4303 3.22949 15.1203V15.2503C3.22949 19.3203 4.66949 20.7603 8.73949 20.7603H15.2595C19.3295 20.7603 20.7695 19.3203 20.7695 15.2503V15.1203C20.7695 11.4103 19.5795 9.93027 16.3795 9.66027C15.9695 9.62027 15.6595 9.26027 15.6995 8.85027C15.7395 8.44027 16.0895 8.13027 16.5095 8.17027C20.4895 8.51027 22.2695 10.6603 22.2695 15.1303V15.2603C22.2695 20.1503 20.1695 22.2503 15.2595 22.2503Z"
        fill={ink}
      />
      <path
        d="M12 15.7501C11.59 15.7501 11.25 15.4101 11.25 15.0001V3.62012C11.25 3.21012 11.59 2.87012 12 2.87012C12.41 2.87012 12.75 3.21012 12.75 3.62012V15.0001C12.75 15.4101 12.41 15.7501 12 15.7501Z"
        fill={ink}
      />
      <path
        d="M15.3499 6.60043C15.1599 6.60043 14.9699 6.53043 14.8199 6.38043L11.9999 3.56043L9.17984 6.38043C8.88984 6.67043 8.40984 6.67043 8.11984 6.38043C7.82984 6.09043 7.82984 5.61043 8.11984 5.32043L11.4699 1.97043C11.7599 1.68043 12.2399 1.68043 12.5299 1.97043L15.8799 5.32043C16.1699 5.61043 16.1699 6.09043 15.8799 6.38043C15.7399 6.53043 15.5399 6.60043 15.3499 6.60043Z"
        fill={ink}
      />
    </svg>
  );
};

export { FigmaUploadFilledIcon };
